<template>
<div class="chapter">
<div class="inner_page">
<p class="ctr" id="d7e139422"><span><a href="#/Text/Morg_9781550924589_epub_c5_r1#d7e2388" id="d14e320">produce list</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c9_r1.vue?370c77d6